import React from 'react';
import { HStack, Text, VStack } from '@chakra-ui/react';
import { useGetMarketplaceRequirements } from '@app/hooks/nft/useGetMarketplaceRequirements';
import { formatNumber, toOptionalFixed } from '@app/helpers/format';
import { useUserXKimAllocationToPlugin } from '@app/hooks/nft/useUserXKimAllocationToPlugin';
import { StakeCartButtonsContainer } from '@app/screens/nft-marketplace/StakeCurtButtonsContainer';
import { usePremiumBuyerNft } from '@app/hooks/nft/usePremiumBuyerNft';
import Link from 'next/link';
import { useChainExplorer } from '@app/hooks/other/useExplorerAddress';
import { useNftMarketplaceFiltersState } from '@app/state/nftMarketplaceFiltersStore';

export const MarketplaceRequirements = () => {
  const { ownedPremiumNFTTokenId } = useNftMarketplaceFiltersState();
  const { data } = useGetMarketplaceRequirements();
  const { data: currentAllocation } = useUserXKimAllocationToPlugin();
  const { name, address } = usePremiumBuyerNft();
  const { explorer } = useChainExplorer();
  const isInWarmUpPeriod =
    currentAllocation &&
    data &&
    +currentAllocation > +data.minAllocationForPremiumListing &&
    !ownedPremiumNFTTokenId;

  return (
    <HStack
      backgroundColor="gray.16"
      borderRadius="16px"
      border="1px solid #1E1E1E"
      padding="12px"
      alignItems="flex-start"
      justifyContent="space-between"
      flex={1}
      maxWidth={['unset', '100%', '60%']}
    >
      <VStack alignItems="flex-start" width="100%" gap={0}>
        <HStack
          alignItems={['flex-start', 'center']}
          justifyContent="space-between"
          width="100%"
          flexDirection={['column', 'row']}
        >
          <Text fontWeight="500" fontSize="18px">
            Participate by Staking
          </Text>
          <StakeCartButtonsContainer />
        </HStack>
        <HStack
          width="100%"
          justifyContent="space-between"
          flexDirection={['column', 'row']}
          alignItems={['flex-start']}
          mt={3}
        >
          <VStack alignItems="flex-start" gap={1} flex={3}>
            {data && (
              <>
                <Text fontSize="14px" color="neutral.400">
                  To participate in standard listing: stake at least{' '}
                  <Text as="span" color="neutral.100">
                    {formatNumber(+data.minAllocationForListing)} xKIM
                  </Text>
                </Text>
                <Text fontSize="14px" color="neutral.400">
                  To participate in{' '}
                  <Text as="span" color="orange">
                    Premium
                  </Text>{' '}
                  listing: stake at least{' '}
                  <Text as="span" color="neutral.100">
                    {formatNumber(+data.minAllocationForPremiumListing)} xKIM
                  </Text>{' '}
                  and own{' '}
                  <Text as="span" color="neutral.100">
                    <Link
                      href={`${explorer?.url}/address/${address}`}
                      target="_blank"
                    >
                      {name}
                    </Link>
                  </Text>{' '}
                  NFT.
                </Text>
                {isInWarmUpPeriod ? (
                  <Text fontSize="14px" color="neutral.400">
                    You are now in warm up period for{' '}
                    <Text as="span" color="orange">
                      Premium
                    </Text>
                    ! You will get your NFT soon!
                  </Text>
                ) : (
                  !ownedPremiumNFTTokenId && (
                    <Text fontSize="14px" color="neutral.400">
                      You will get it within 24 hours once staked required
                      amount.
                    </Text>
                  )
                )}
              </>
            )}
          </VStack>
          <VStack
            alignItems={['center', 'flex-end']}
            flexDirection={['row', 'column']}
            justifyContent="space-between"
            width={['100%', 'unset']}
            gap={1}
            flex={1}
          >
            <Text fontSize="14px" color="neutral.400">
              Staked amount
            </Text>
            <Text fontSize="18px" color="neutral.100">
              {currentAllocation ? toOptionalFixed(+currentAllocation, 2) : '-'}{' '}
              xKIM
            </Text>
          </VStack>
        </HStack>
      </VStack>
    </HStack>
  );
};
